import { useMutation, useQueryClient } from "react-query";
import { updateTcs as updateTcsAPi } from "../apis";
import { toast } from "sonner";

export const useTCSEdit = () => {
    const queryClient = useQueryClient()
    const { mutate: updateTCS, isLoading: loading, isSuccess } = useMutation({
        mutationFn: updateTcsAPi,
        onSuccess: ()=>{
            toast.success('TCS updated successfully')
            queryClient.invalidateQueries(['orderDetails'])
        },
        onError: (error: any) => {
            toast.error('Failed to update TCS')
        }
    })
    return {
        updateTCS,
        loading,
        isSuccess
    }
}
